import { Dialog } from '@mui/material';
import * as React from 'react';

import MuiStyles from './styles';
import { DisconnectedModalProps } from './types';

export default function DisconnectedModal(props: DisconnectedModalProps) {
    const {
        disconnected,
        connected
    } = props;

    const classes = MuiStyles(props);

    return (
        <Dialog
            disableEscapeKeyDown
            open={connected && disconnected}
        >
            <div className={classes.content}>
                <p className={classes.loader}>Connecting...</p>
                <h1 className={classes.title}>Warning</h1>
                <p>
                    You have been disconnected from the server. We are attempting to reconnect.
                    If you are not reconnected in a few minutes, please contact support.
                </p>
            </div>
        </Dialog>
    );
}